<template>
  <div class="page-container">
    <drag-zoom-container v-if="topoGraph.graphNodeList.length > 0">
      <div class="topo-graph-container" id="topo-graph-container">
        <!-- 母线 >>> 关口电表 >>> 母线 >>> 变压器 >>> 关口电表 >>> 母线 >>> 并网点电表 >>> 负载|负载电表等 -->
        <template v-for="node in topoGraph.graphNodeList">
          <div class="node-container minitopo-bus" v-if="node.type == 'cable'" :style="styleFromNode(node)">母线</div>
          <div class="node-container minitopo-transformer" v-if="node.type == 'transformer'"
            :style="styleFromNode(node)">
            <img src="./icons/ic_transformer.png" alt="" class="node-icon transformer-icon">
            <span class="node-label">变压器</span>
          </div>
          <div class="node-container minitopo-eblock" v-if="node.type == 'eblock'" :style="styleFromNode(node)">
            <img src="./icons/eblock.png" alt="" class="node-icon">
            <span class="node-label">{{ node.label }}</span>
          </div>
          <div class="node-container minitopo-elink" v-if="node.type == 'elink'" :style="styleFromNode(node)">
            <img src="./icons/elink.png" alt="" class="node-icon">
            <span class="node-label">{{ node.label }}</span>
          </div>
          <div class="node-container minitopo-node" v-if="node.type == 'payload'" :style="styleFromNode(node)">
            <img src="./icons/pload.png" alt="" class="node-icon">
            <span class="node-label">负载</span>
          </div>
          <div class="node-container minitopo-node" v-if="node.type == 'power_station_photovoltaic'"
            :style="styleFromNode(node)">
            <img src="./icons/pv.png" alt="" class="node-icon">
            <span class="node-label">光伏</span>
          </div>
          <div class="node-container minitopo-node" v-if="node.type == 'power_station_storage'"
            :style="styleFromNode(node)">
            <img src="./icons/ess.png" alt="" class="node-icon">
            <span class="node-label">储能系统</span>
          </div>
          <div class="node-container minitopo-node" v-if="node.type == 'charge_pile'" :style="styleFromNode(node)">
            <img src="./icons/pile.png" alt="" class="node-icon">
            <span class="node-label">充电桩</span>
          </div>
        </template>
        <template v-for="node in topoGraph.graphNodeList">
          <div class="node-container minitopo-meter" v-if="node.type == 'meter'" :style="styleFromNode(node)">
            <img src="./icons/meter.png" alt="" class="node-icon">
            <label class="minitopo-label">
              <span class="node-label" :title="node.label">{{ node.label }}</span>
              <input type="checkbox" v-model="selectedMeters" :value="node.uuid" v-if="false">
            </label>
          </div>
        </template>
        <template v-for="path in topoGraph.graphPathList">
          <MiniTopoPath :points="path.points" :nodeWidth="topoGraph.nodeDefaultStyle.width"
            :nodeHeight="topoGraph.nodeDefaultStyle.height" />
        </template>
      </div>
    </drag-zoom-container>
    <div v-else class="no-data">暂无拓扑</div>

  </div>
</template>

<script setup>
import { computed, ref, watch, onMounted, reactive } from 'vue'
import { v2 as apiV2, topoApi } from "@/api/modules/station/index.js";
import MiniTopoPath from './miniTopoPath.vue'

import { useAppStore } from "@/store/modules/app";
const appStore = useAppStore();
const { stationId } = appStore.useStationState({
  stationIdWatch() {
    stationIdChangeCb(stationId.value);
  }
});


const topoGraph = reactive({
  nodeList: [],
  edgeList: [],
  nodeDefaultStyle: {
    width: 140, // 默认单位px
    height: 30,
  },
  graphNodeList: [],
  graphPathList: [],
})

// 设置画布尺寸的配置 >>> 设置画布大小&画布在容器中的位置
const sizeConfig = reactive({
  top: 20, // 最上方的节点距离画布容器顶部**px
  offsetX: 30,
  offsetY: 0,
  minRect: {
    t: 0,
    b: 0,
    l: 0,
    r: 0,
  },
  /**
   * 引用定时器。
   * 为提升性能，不等挂载就开始请求数据。
   * >>> 拿到数据后，计算画布的真是尺寸并设置到DOM，但此时可能还未挂载。
   * >>> 定时查看是否已挂载，挂载 >>> 设置size >>> 清除定时器。
   */
  timer: null,
})

onMounted(() => { })


function stationIdChangeCb(id) {
  initPageByStation(id);
}

function initPageByStation(stationId = stationId.value) {
  getTopoData(stationId).then(async () => {
    // 获取各节点的label值
    await refreshNodesLabel(stationId);
    // 使用dagre处理请求回来的topo节点数据
    formatGraphDataByDagre(stationId);
  });

}


/**
 * 获取拓扑数据，返回节点列表和edge列表
 */
function getTopoData(stationId = stationId.value) {
  const edgeList = [];
  const nodeList = [];

  return topoApi.getTopology(stationId).then(res => {
    if (!(res?.data?.stationTopology)) {
      topoGraph.nodeList = [];
      topoGraph.edgeList = [];
      return;
    }
    /** 从接口返回的json中，解析拓扑图的各种信息，如：节点、edge
     * applyBg[bool] | bgColor[string] | cells[array] | grid[bool]
     */
    const topoInfo = JSON.parse(res?.data?.stationTopology)
    if (topoInfo?.cells && Array.isArray(topoInfo.cells)) {
      topoInfo.cells.forEach(cell => {
        if (cell.shape == 'edge') {
          const sourceId = (typeof cell.source.cell === 'string') ? cell.source.cell : cell.source.cell.id
          const targetId = (typeof cell.target.cell === 'string') ? cell.target.cell : cell.target.cell.id
          edgeList.push({
            source: sourceId,
            target: targetId
          })
        } else {
          nodeList.push({
            id: cell.id,
            uuid: cell.data.uuid,
            type: cell.data.type,
            label: '--', // 先整理拓扑图的节点，在渲染前format信息，labelFromUUID(cell.data.uuid)
            width: cell.size.width,
            height: cell.size.height,
          })
        }
      });
    }
    topoGraph.nodeList = nodeList;
    topoGraph.edgeList = edgeList;
  }).catch(err => {
    console.error(err);
    topoGraph.nodeList = [];
    topoGraph.edgeList = [];
  })
}

/**
 * 更新nodes的label
 */
async function refreshNodesLabel(stationId = stationId.value) {
  const deviceList = await getDevicesInfo(stationId);
  if (deviceList && Array.isArray(deviceList)) {
    topoGraph.nodeList.forEach(node => {
      node.label = deviceList.find(it => it.uuid == node.uuid)?.label ?? '--';
    })
  }
}



/** 使用dagre处理请求回来的topo节点数据 */
function formatGraphDataByDagre() {
  /** 注意事项：
   * 需在项目中引入dagre包：index.html >>> 设置script标签src="/dagre/index.js"
   * dagre使用参考：
   *    https://github.com/dagrejs/dagre/wiki
   *    https://juejin.cn/post/7257321872424009783
   *    https://juejin.cn/post/6844904185322815496
   */

  /** 实例化dagre的fraph，并初始化 */
  const g = new dagre.graphlib.Graph({});
  const graphConfig = {
    rankdir: 'TB',
    ranker: 'longest-path',
    align: undefined, // 设置相同 rank 中 node 节点的对齐方式。 默认undefined，可取值：UL（上左）, UR（上右）, DL（下左）, DR（下右）
    nodesep: 200, // 相同层级 rank 中 node 的间距。默认 50
    edgesep: 40, // edge 之间的间距。默认 10
    ranksep: 60, // 即相邻层级之间的间距，默认 50
    marginx: 0, // 图整体与画布的左右间距。默认 0
    marginy: 0, // 图整体与画布的上下间距。默认 0 
  }
  g.setGraph(graphConfig);
  g.setDefaultEdgeLabel(() => { return {}; });


  /** 将 nodeList & edgeList 设置到graph实例，执行layout方法，对数据进行转换，之后通过graph实例获取转化后的数据 */
  topoGraph.nodeList.forEach(node => {
    // 配置节点的基本信息和样式
    const option = {
      label: node.label,
      width: (node.label == 'cable') ? 300 : topoGraph.nodeDefaultStyle.width,
      height: topoGraph.nodeDefaultStyle.height,
      type: node.type,
      uuid: node.uuid
    }
    g.setNode(node.id, option)
  })

  topoGraph.edgeList.forEach(edge => {
    g.setEdge(edge.source, edge.target)
  })

  dagre.layout(g);

  /** 从graph实例中获取转化后的nodes&edges数据，调整后在当前组件中渲染 */
  const res = formatPositionForDagreGraph(g);
  topoGraph.graphNodeList = res.graphNodeList;
  topoGraph.graphPathList = res.graphEdgeList;
}


function formatPositionForDagreGraph(dagreGraph) {
  let graphNodeList = dagreGraph.nodes().map(it => dagreGraph.node(it));
  let graphEdgeList = dagreGraph.edges().map(it => dagreGraph.edge(it));

  // 获取画布需要的最小尺寸
  graphNodeList.forEach((node, idx) => {
    if (idx == 0) {
      sizeConfig.minRect.t = node.y;
      sizeConfig.minRect.b = node.y + node.height;
      sizeConfig.minRect.l = node.x;
      sizeConfig.minRect.r = node.x + node.width;
    } else {
      if (node.y < sizeConfig.minRect.t) {
        sizeConfig.minRect.t = node.y;
      }
      if ((node.y + node.height) > sizeConfig.minRect.b) {
        sizeConfig.minRect.b = node.y + node.height;
      }
      if (node.x < sizeConfig.minRect.l) {
        sizeConfig.minRect.l = node.x;
      }
      if ((node.x + node.width) > sizeConfig.minRect.r) {
        sizeConfig.minRect.r = node.x + node.width;
      }
    }
  })

  // 手动修复连线没有在node中间的问题
  // graphEdgeList.forEach(edge => {
  //   if (edge.points && Array.isArray(edge.points)) {
  //     edge.points.forEach(p => {
  //       p.x += 20; // 便宜量的经验值 = (node.width - 100) / 2;
  //       // p.y += 0;
  //     })
  //   }
  // })

  // 移动节点&连线，设置画布的size为最小尺寸
  graphNodeList.forEach(node => {
    node.x = node.x - sizeConfig.minRect.l + sizeConfig.offsetX;
    node.y = node.y - sizeConfig.minRect.t + sizeConfig.offsetY;
  })
  graphEdgeList.forEach(edge => {
    if (edge.points && Array.isArray(edge.points)) {
      edge.points.forEach(p => {
        p.x = p.x - sizeConfig.minRect.l + sizeConfig.offsetX;
        p.y = p.y - sizeConfig.minRect.t + sizeConfig.offsetY;
      })
    }
  })

  // 设置画布容器的尺寸大小
  if (graphNodeList.length > 0) {
    const graphDom = document.getElementById('topo-graph-container');
    if (graphDom) {
      graphDom.style.width = (sizeConfig.minRect.r - sizeConfig.minRect.l) + 'px';
      graphDom.style.height = (sizeConfig.minRect.b - sizeConfig.minRect.t) + 'px';
    } else {
      sizeConfig.timer = setInterval(() => {
        const graphDom = document.getElementById('topo-graph-container');
        if (graphDom) {
          clearInterval(sizeConfig.timer);
          graphDom.style.width = (sizeConfig.minRect.r - sizeConfig.minRect.l) + 'px';
          graphDom.style.height = (sizeConfig.minRect.b - sizeConfig.minRect.t) + 'px';
        }
      }, 100);
    }
  }
  return { graphNodeList, graphEdgeList }
}


/** ======[辅助-功能方法]=============================================================================================================== */

// 获取设备信息
function getDevicesInfo(stationId = stationId.value) {
  const deviceList = [];
  return apiV2.getDevicesByIdV2(stationId).then(res => {
    // outerMeter设备
    if (res?.data?.outerMeters && Array.isArray(res.data.outerMeters)) {
      res.data.outerMeters.forEach(meter => {
        deviceList.push({
          type: 'outerMeter',
          uuid: meter.uuid,
          label: meter.meterName,
          isMeter: true,
        })
      })
    }

    // eLink相关设备
    if (res?.data?.eLinks && Array.isArray(res.data.eLinks)) {
      res.data.eLinks.forEach(eLink => {
        // eLink
        deviceList.push({
          type: 'eLink',
          uuid: eLink.uuid,
          label: eLink.eLinkName,
        })

        // eLink下的计量电表
        if (Array.isArray(eLink.measureMeters)) {
          eLink.measureMeters.forEach(measureMeter => {
            deviceList.push({
              type: 'measureMeter',
              uuid: measureMeter.uuid,
              label: measureMeter.meterName,
              isMeter: true,
              isELinkMeter: true,
            })
          })
        }

        // eLink下的eBloc
        if (Array.isArray(eLink.eBlocks)) {
          eLink.eBlocks.forEach(eBlock => {
            deviceList.push({
              type: 'eBlock',
              uuid: eBlock.uuid,
              label: eBlock.eBlockName,
            })
          })
        }
      })
    }
    return deviceList;

  }).catch(err => {
    console.error(err);
    return [];
  })
}


/** 根据node信息计算style */
function styleFromNode(node) {
  return {
    left: node.x + 'px',
    top: node.y + 'px',
    // width: node.width + 'px',
    // height: node.height + 'px',
    'z-index': 2
  }
}


</script>

<style lang='scss'>
.page-container {
  width: 100%;
  height: 100%;
  opacity: 1;


  .topo-graph-container {
    position: relative;
    left: 0px;
    height: 100%;
    width: 100%;
    font-size: 12px;

    .node-container {
      position: absolute;
      width: 148px;


      display: flex;
      justify-content: center;
      align-items: center;
      // background: aqua;

      .node-icon {
        width: 44px;
        height: 60px;
        background: #1F2536;

        &.transformer-icon {
          width: 33px;
          height: fit-content;
        }
      }

      .node-label {
        width: 100px;
        text-align: right;
        position: absolute;
        right: 110px;
        font-family: PingFang-SC, PingFang-SC;
        font-weight: 500;
        font-size: 16px;
        color: #94A0BA;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &.minitopo-bus {
        width: 144px;
        height: 44px;
        background: #205849;
        border-radius: 5px 5px 5px 5px;
        border: 2px solid #41FBA5;
      }
    }

  }

  .no-data {
    width: 100%;
    height: 100%;
    min-height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'HarmonyOS Sans SC', sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: rgba(46, 46, 46, 0.4);
    background: #FFFFFF;
    border-radius: 8px;
  }
}
</style>
